import { isMobile } from 'react-device-detect';
import {
  CHAT_BOT,
  LAYOUT_COLUMNS,
  LAYOUT_LIST,
  LayoutListDefinition
} from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';

export const Simulation: Translator = sequence => {
  const LayoutListItems: LayoutListDefinition[] = [];

  const root = translate(sequence, item => {
    if (item.__typename === 'ChatBot') {
      LayoutListItems.push({
        id: `${item.id}_list`,
        type: LAYOUT_LIST,
        values: {
          align: 'center',
          padded: !isMobile
        },
        items: [
          {
            type: CHAT_BOT,
            id: item.id,
            values: {
              title: item.title,
              description: item.body,
              conversationBotId: item.conversationBotId,
              picture:
                item.pictures && item.pictures.length > 0
                  ? item.pictures[0]
                  : undefined
            },
            items: []
          }
        ]
      });
    }

    return null;
  });

  root.items.push({
    type: LAYOUT_COLUMNS,
    id: '1',
    values: {},
    items: LayoutListItems
  });

  return root;
};
